import { useState } from "react";
import {
    HStack, Image, VStack, Box,
    DrawerRoot, DrawerBackdrop, DrawerPositioner, DrawerContent,
} from "@chakra-ui/react";
import {useTranslation} from "react-i18next";
import Logo from '@/assets/images/cyberjob_dialogflow_logo.svg';
import LanguageSelector from "@/components/ui/menu/LanguageSelector";
import TopBar from '@/components/layout/TopBar';
import {Outlet} from "react-router-dom";
import MenuItem from "@/components/ui/menu/MenuItem";
import { HiOutlineCpuChip, HiOutlineCog6Tooth } from "react-icons/hi2";
import { PageHeaderProvider } from "@/components/layout/PageHeaderContext";

const SidebarNav = ({ t, onClose }) => (
    <VStack
        bg="bg.secondary"
        h={'100vh'}
        w={260}
        alignItems={'flex-start'}
        py={6}
        borderRightWidth={'1px'}
        borderRightColor={'border.primary'}
    >
        <Image src={Logo} w={'70%'} ml={4}/>
        <VStack mt={10} w={'100%'} h={'full'} justifyContent={'space-between'}>
            <VStack w={'100%'}>
                <MenuItem label={t("nav.models")} url="/models" icon={<HiOutlineCpuChip />} onClick={onClose} />
                <MenuItem label={t("nav.accountSettings")} url="/account-settings" icon={<HiOutlineCog6Tooth />} onClick={onClose} />
            </VStack>
            <VStack w={'100%'} px={4} rowGap={4}>
                <LanguageSelector/>
            </VStack>
        </VStack>
    </VStack>
);

const Layout = () => {
    const {t} = useTranslation("common");
    const [isSidebarOpen, setIsSidebarOpen] = useState(false);

    return (
        <HStack w={'full'} minH={'100vh'} gap={0} alignItems={'flex-start'}>
            {/* Desktop sidebar */}
            <Box minW={260} display={{ base: 'none', md: 'block' }}>
                <Box pos={'fixed'} w={260} h={'100vh'}>
                    <SidebarNav t={t} />
                </Box>
            </Box>

            {/* Mobile drawer */}
            <DrawerRoot
                open={isSidebarOpen}
                onOpenChange={(e) => setIsSidebarOpen(e.open)}
                placement="start"
            >
                <DrawerBackdrop />
                <DrawerPositioner>
                    <DrawerContent p={0} maxW={260} bg="bg.secondary">
                        <SidebarNav t={t} onClose={() => setIsSidebarOpen(false)} />
                    </DrawerContent>
                </DrawerPositioner>
            </DrawerRoot>

            <PageHeaderProvider>
                <VStack alignItems={'flex-start'} w={'full'} minW={0} minH={'100vh'} gap={0}>
                    <TopBar onSidebarOpen={() => setIsSidebarOpen(true)} />
                    <VStack w={'100%'} minW={0} maxW={'full'} py={6} px={{ base: 4, md: 6 }} pt={{ base: 24, md: 6 }}>
                        <Outlet />
                    </VStack>
                </VStack>
            </PageHeaderProvider>
        </HStack>
    );
};

export default Layout;
